var map = {
	"./bigposs_logo.png": "4bf0",
	"./bigposs_logo.svg": "a9b9",
	"./cancelled-order.svg": "ec07",
	"./cash-register.svg": "b5f5",
	"./empty-cart.svg": "abd0",
	"./hub-approve.svg": "3f2a",
	"./login-footer.jpg": "a33a",
	"./logo.svg": "6e52",
	"./order-reached.svg": "bd5d",
	"./payment-method.svg": "5a30",
	"./qr-code-scan.svg": "189f",
	"./send-order.svg": "07d6",
	"./stc_logo.png": "b4a8",
	"./stock-order-draft.svg": "dec1",
	"./waiting-approve.svg": "5d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e4b";